export default function normalizeMessages(messages) {
    if (!messages) {
        return [];
    }

    if (!Array.isArray(messages)) {
        return [messages];
    }

    return messages;
}



// WEBPACK FOOTER //
// ./src/frontend/components/Fields/normalizeMessages.js